// extracted by mini-css-extract-plugin
export default {"list":"AdditionalLR_list__38vrV"};